/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Při získávání způsobů dopravy došlo k chybě. Prosím zkuste znovu.`
};

const da_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Der opstod en fejl under hentning af leveringsmetoder. Prøv venligst igen.`
};

const de_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Beim Abrufen der Versandarten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`
};

const en_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `An error occurred while retriving shipping methods. Please try again.`
};

const es_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Se produjo un error al recuperar los métodos de envío. Por favor, inténtalo de nuevo.`
};

const fr_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite lors de la récupération des modes d'expédition. Veuillez réessayer.`
};

const hu_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Hiba történt a szállítási módok lekérése során. Kérjük, próbálkozz újra.`
};

const it_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante il recupero dei metodi di spedizione. Riprova.`
};

const nl_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een fout opgetreden bij het ophalen van de verzendmethoden. Probeer het opnieuw.`
};

const pl_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Wystąpił błąd podczas pobierania metod wysyłki. Spróbuj ponownie.`
};

const pt_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro ao recuperar os métodos de envio. Por favor, tente novamente.`
};

const sv_checkout_get_methods_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ett fel uppstod vid hämtning av leveranssätt. Försök igen.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_get_methods_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_get_methods_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_get_methods_error", locale)
	if (locale === "cs") return cs_checkout_get_methods_error(inputs)
	if (locale === "da") return da_checkout_get_methods_error(inputs)
	if (locale === "de") return de_checkout_get_methods_error(inputs)
	if (locale === "en") return en_checkout_get_methods_error(inputs)
	if (locale === "es") return es_checkout_get_methods_error(inputs)
	if (locale === "fr") return fr_checkout_get_methods_error(inputs)
	if (locale === "hu") return hu_checkout_get_methods_error(inputs)
	if (locale === "it") return it_checkout_get_methods_error(inputs)
	if (locale === "nl") return nl_checkout_get_methods_error(inputs)
	if (locale === "pl") return pl_checkout_get_methods_error(inputs)
	if (locale === "pt") return pt_checkout_get_methods_error(inputs)
	return sv_checkout_get_methods_error(inputs)
};
export { checkout_get_methods_error as "checkout.get_methods_error" }